import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import map from 'lodash/map';
import get from 'lodash/get';
import split from 'lodash/split';
import filter from 'lodash/filter';
import { useAction } from 'hooks';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Link from 'components/Link';
import Information from 'modules/Information';
import FormGroup from 'components/Form/FormGroup';
import App from 'modules/App';
import { CONSENT_MODAL } from 'modules/Mobile/constants';
import { AppContext } from 'context';
import { SIGN_UP_FORM } from '../../../../constants';
import { useIsMinor } from '../hooks';
import { getUrlWithLocale } from '../../helpers';
import { RegistrationPrivacyFooter, RegistrationPrivacyMessage } from './renderers';
import useConsentsEffects from './useConsentsEffects';
const rawPolicyLink = 'https://support.glucocontro.online/hc/articles/360012770119-Privacy-Policy';
const TermsOfServiceAndPrivacy = ({ stepValidatorRules, setStepValidatorRules })=>{
    const { isAlpineEnabled } = useContext(AppContext);
    const locale = useSelector(App.selectors.langCode);
    const consentsTemplate = useSelector(Information.selectors.consentsTemplate);
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const localizationResources = useSelector(App.selectors.localizationResources);
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const openModal = useAction(App.actions.openModal, CONSENT_MODAL);
    const setStaticFilesDir = useAction(App.actions.setStaticFilesDir);
    const setFormValue = useAction(App.actions.setFormValue, SIGN_UP_FORM);
    const countryCode = get(formValues, 'values.countryCode');
    const termsOfService = filter(consentsTemplate, (consent)=>consent.type === 'TermsOfService');
    const privacyPolicy = filter(consentsTemplate, (consent)=>consent.type === 'PrivacyAndHealthData');
    let policyConsentUrl = '';
    if (privacyPolicy.length === 1) {
        const { consentUrl } = privacyPolicy[0];
        policyConsentUrl = consentUrl;
    }
    const policyUrlWithLocale = getUrlWithLocale(policyConsentUrl, locale);
    useConsentsEffects(stepValidatorRules, setStepValidatorRules);
    const isMinor = useIsMinor();
    if (isMinor || !countryCode || !termsOfService || !termsOfService.length) return null;
    const onClickHandler = (e, dir)=>{
        setStaticFilesDir(dir);
        if (isAlpineEnabled === 'true') {
            if (isMobileDisplayMode) {
                openModal();
                e.preventDefault();
            }
        }
    };
    const renderLegalConsent = ({ legalConsentId, consentPromptKey, consentUrl, isMandatory }, shouldAddRegistrationPrivacy = false)=>{
        const urlWithLocale = getUrlWithLocale(consentUrl, locale);
        let consentPrompt = get(localizationResources, [
            consentPromptKey,
            'value'
        ], '');
        if (consentPrompt && consentUrl) {
            const strings = split(consentPrompt, /<[^>]+>/);
            const link = strings.length > 1 ? /*#__PURE__*/ _jsx(Link, {
                to: isAlpineEnabled === 'true' ? urlWithLocale : consentUrl,
                target: "_blank",
                onClick: (e)=>onClickHandler(e, App.constants.STATIC_FILES_SETTINGS.EULA),
                children: strings[1]
            }) : null;
            consentPrompt = /*#__PURE__*/ _jsxs("span", {
                children: [
                    strings[0],
                    link,
                    strings[2]
                ]
            });
        }
        const asterisk = isMandatory && !isMobileDisplayMode ? /*#__PURE__*/ _jsx("span", {
            children: "* "
        }) : '';
        const labelMessage = /*#__PURE__*/ _jsxs("span", {
            children: [
                asterisk,
                consentPrompt,
                shouldAddRegistrationPrivacy && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        '. ',
                        /*#__PURE__*/ _jsx(RegistrationPrivacyMessage, {
                            consentUrl: isAlpineEnabled === 'true' ? policyUrlWithLocale : rawPolicyLink
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: `legalConsent-${legalConsentId}`,
            formValues: formValues,
            children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                inputValue: "true",
                labelMessage: labelMessage,
                onChange: setFormValue
            })
        }, legalConsentId);
    };
    if (termsOfService.length === 1) {
        return renderLegalConsent(termsOfService[0], true);
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-7",
        children: [
            map(termsOfService, (legalConsent)=>renderLegalConsent(legalConsent)),
            privacyPolicy.length === 1 && /*#__PURE__*/ _jsx(RegistrationPrivacyFooter, {
                consentUrl: isAlpineEnabled === 'true' ? policyUrlWithLocale : rawPolicyLink
            })
        ]
    });
};
export default TermsOfServiceAndPrivacy;
